import { render, staticRenderFns } from "./Obras.vue?vue&type=template&id=eb5083e6&"
import script from "./Obras.vue?vue&type=script&lang=js&"
export * from "./Obras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports